import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
// Replace with your Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyDPFVFo7bvdTaggHux40scjNIcNvNIjgaw",
  authDomain: "sandiegomailer-eebc2.firebaseapp.com",
  projectId: "sandiegomailer-eebc2",
  storageBucket: "sandiegomailer-eebc2.firebasestorage.app",
  messagingSenderId: "61582689749",
  appId: "1:61582689749:web:4666cefcb448dc71d3a95c",
  measurementId: "G-YVG9NEDBBB"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Firebase Analytics
export const analytics = getAnalytics(app);

export default app;
